export const InternetPhoneSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، مرکز تماس ابری، خط تلفن اینترنتی و پنل پیامکی.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-82800000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/internet-phone/#webpage",
      "url": "https://navatel.ir/products/internet-phone/",
      "name": "خرید خط تلفن اینترنتی (تلفن VoIP) | نواتل",
      "description": "خط تلفن اینترنتی نواتل مانند یک شماره تلفن ثابت معمولی عمل می‌کند، با این تفاوت که تماس‌ها از طریق اینترنت برقرار می‌شوند؛ بدون نیاز به سیم‌کشی و تجهیزات سنتی.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/internet-phone/#service"
      },
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/internet-phone/#breadcrumb"
      }
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/internet-phone/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "خط تلفن اینترنتی",
          "item": "https://navatel.ir/products/internet-phone/"
        }
      ]
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/products/internet-phone/#service",
      "name": "خط تلفن اینترنتی نواتل",
      "alternateName": "تلفن ثابت ابری نواتل (VoIP)",
      "serviceType": "خط تلفن ثابت اینترنتی / تلفن اینترنتی (Cloud VoIP Line)",
      "description": "خط تلفن اینترنتی نواتل مانند یک شماره تلفن ثابت معمولی عمل می‌کند اما تماس‌ها از طریق اینترنت برقرار می‌شوند؛ بدون نیاز به سیم‌کشی سنتی. امکان تماس با تمامی شماره‌های ثابت و همراه وجود دارد و شماره به محل جغرافیایی کسب‌وکار وابسته نیست. هزینه نمایش‌داده‌شده صرفاً اشتراک سالانه سرویس است و شامل هزینه انتخاب شماره اختصاصی/رند نمی‌شود که در صفحه‌ای جداگانه ارائه می‌گردد.",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "کسب‌وکارها و سازمان‌ها (B2B)"
      },
      "url": "https://navatel.ir/products/internet-phone/",
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "راه‌اندازی",
          "value": "رایگان"
        },
        {
          "@type": "PropertyValue",
          "name": "دوره پرداخت",
          "value": "اشتراک سالانه (نمایش قیمت به‌صورت ماهانه)"
        }
      ],
      "offers": [
        {
          "@type": "Offer",
          "name": "اشتراک خط تلفن اینترنتی - سرشماره ۹۱۶۹",
          "description": "هزینه ثابت خط اینترنتی نواتل شامل هزینه خط و اشتراک؛ قابل خریداری در تهران و سایر استان‌های کشور، با قابلیت رجیستر در واتساپ بیزینس.",
          "url": "https://navatel.ir/products/internet-phone/",
          "priceCurrency": "IRR",
          "price": "1620000",
          "availability": "https://schema.org/InStock",
          "areaServed": {
            "@type": "Country",
            "name": "Iran"
          },
          "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "priceCurrency": "IRR",
            "price": "1620000",
            "unitText": "ماه",
            "billingDuration": "P1Y"
          }
        },
        {
          "@type": "Offer",
          "name": "اشتراک خط تلفن اینترنتی - سرشماره‌های ۸۲۸۰، ۸۷۲۱ و ۸۱۶۴",
          "description": "هزینه ثابت خط اینترنتی نواتل شامل هزینه خط و اشتراک؛ قابل خریداری در تهران و سایر استان‌های کشور.",
          "url": "https://navatel.ir/products/internet-phone/",
          "priceCurrency": "IRR",
          "price": "2520000",
          "availability": "https://schema.org/InStock",
          "areaServed": {
            "@type": "Country",
            "name": "Iran"
          },
          "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "priceCurrency": "IRR",
            "price": "2520000",
            "unitText": "ماه",
            "billingDuration": "P1Y"
          }
        }
      ]
    }
  ]
}